@if (!editMode) {
	<span
		class="name-preview"
		[ngClass]="namePreviewClasses"
		(click)="previewClickHandler()"
	>
		{{ formControl.value }}
	</span>
}

@if (editMode) {
	<mat-form-field
		class="no-label au-header-input width-100"
		[ngClass]="namePreviewClasses"
	>
		<input
			#inputControl
			[formControl]="formControl"
			matInput
			[placeholder]="placeholder"
			maxLength="{{ 100 }}"
			type="text"
			(blur)="onBlurHandler()"
			(keydown.enter)="submitKeydown($event)"
			[auAutofocus]="autofocusEnabled"
			[focusTimeout]="400"
		/>
		@if (formControl.value) {
			<mat-hint align="end">
				<span class="text-blue">
					{{ formControl.value.length }} /
					{{ 100 }}
				</span>
			</mat-hint>
		}
		<mat-error>
			@if (formControl.errors?.required) {
				<span>{{ 'required' | translate }}</span>
			}
			@if (formControl.errors?.whitespace) {
				<span>{{ 'spaces_only_restricted' | translate }}</span>
			}
		</mat-error>
	</mat-form-field>
}
